/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  const headerDesktop = document.querySelector('.header__desktop');
  const headerMobile = document.querySelector('.header__mobile');
  const mobileLogo = document.querySelector('.header__logo');

  function updateHeaderVisibility() {
    if (headerDesktop && headerMobile) {
      if (window.innerWidth >= 768) {
        headerMobile.style.display = 'none';
        headerDesktop.style.maxHeight = '100%';
        headerDesktop.style.opacity = '1';
        headerDesktop.style.visibility = 'visible';
        headerDesktop.style.pointerEvents = 'all';
      } else {
        headerMobile.style.display = 'flex';
        headerMobile.style.justifyContent = 'space-between';
        headerDesktop.style.maxHeight = '0';
        headerDesktop.style.opacity = '0';
        headerDesktop.style.visibility = 'hidden';
        headerDesktop.style.pointerEvents = 'none';
      }
    }
  }

  if (window.innerWidth < 768) {
    headerMobile.style.display = 'flex';
    headerMobile.style.justifyContent = 'space-between';
    headerMobile.style.alignItems = 'center';
    mobileLogo.style.width = '40%';
  }

  // Initial check
  updateHeaderVisibility();

  // Add resize event listener
  window.addEventListener('resize', updateHeaderVisibility);

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

// Custom add to cart button text (Buy buttons block setting).
// theme.js resets the label to the default on load and on every variant change,
// so re-apply it afterwards. Disabled buttons keep their "Sold out" text.
(function() {
  function applyAddToCartLabels() {
    document.querySelectorAll('[data-add-to-cart][data-add-to-cart-label]').forEach(function(button) {
      const text = button.querySelector('[data-add-to-cart-text]');
      if (text && !button.disabled) {
        text.textContent = button.getAttribute('data-add-to-cart-label');
      }
    });
  }

  applyAddToCartLabels();
  document.addEventListener('theme:variant:change', applyAddToCartLabels);
})();
